import { render } from "./milestone-navigation-tab.vue?vue&type=template&id=c694bc6e&ts=true"
import script from "./milestone-navigation-tab.vue?vue&type=script&lang=ts"
export * from "./milestone-navigation-tab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__